<section class="hero-area-bg" id="hero-area">
    <div class="container">
        <div class="row align-items-center row-flex">
            <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12 left-bg">
                <div class="neet-contents">
                    <h1 class="head-title">Your Code to <span class="head-span">Success</span><br> in NEET</h1>
                    <p>Start your free live classes with India’s Top Faculties</p>
                    <div class="number-field m-auto" [formGroup]='mobileNumberForm'>
                        <span class="code">+ 91</span>
                        <input type="tel" maxlength="10" class="numbertest-input"  placeholder="MOBILE NUMBER" formControlName='mobilenumber'>
                        <button type="button" (click)="signup('neet_lc_1', {number: mobileNumberForm.value.mobilenumber, dialCode: '+91'})" 
                            class="start-btn"><b>START LEARNING </b></button>
                    </div>
                    <div class="d-flex justify-content-center IL_sc-click font-weight-bold">
                        <span class="assessment_mt-10" *ngIf="tenant != 'srichaitanya'">Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
                    </div>
                </div>

            </div>

            <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12 right-bg">
                <div class="intro-img">
                    <img src="assets/img/neet-landing/neet-introgirl.png" class="img-fluid deskimg-show" alt="">
                    <img src="assets/img/neet-landing/1.png" class="img-fluid mobile-show" alt="">
                </div>

            </div>

        </div>

    </div>


</section>
<section class="whatyouget-area">
    <div class="container">
        <div class="whatyouget-head">
            <h1>What all you <span class="head-span">get</span> </h1>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-12 col-xs-12">
                <div class="get-item">
                    <div>
                        <figure class="get-img">
                            <img src="assets/img/neet-landing/g1.png" alt="" class="img-fluid">
                        </figure>
                    </div>
                    <div class="get-content">
                        <h3>Interactive Live Classes</h3>
                        <p>No more boring sessions, faculties make sure they make your learning interesting and
                            interactive.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12 col-xs-12">
                <div class="get-item">
                    <div>
                        <figure class="get-img">
                            <img src="assets/img/neet-landing/g2.png" alt="" class="img-fluid">
                        </figure>
                    </div>
                    <div class="get-content">
                        <h3>Exams, Quizzes and Analysis</h3>
                        <p>Your exams are not just about marks but to give you an in-depth analysis on where you
                            need more attention to succeed.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12 col-xs-12">
                <div class="get-item">
                    <div>
                        <figure class="get-img">
                            <img src="assets/img/neet-landing/g3.png" alt="" class="img-fluid">
                        </figure>
                    </div>
                    <div class="get-content">
                        <h3>Concept Clarity</h3>
                        <p>We make sure to clarify your concepts to increase your chances for better results.
                            Concept clear, exam clear.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12 col-xs-12">
                <div class="get-item">
                    <div>
                        <figure class="get-img">
                            <img src="assets/img/neet-landing/g4.png" alt="" class="img-fluid">
                        </figure>
                    </div>
                    <div class="get-content">
                        <h3>Well Organized</h3>
                        <p>The course is well aligned with your regular school syllabus to make sure you are well
                            ahead of your competition.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12 col-xs-12">
                <div class="get-item">
                    <div>
                        <figure class="get-img">
                            <img src="assets/img/neet-landing/g5.png" alt="" class="img-fluid">
                        </figure>
                    </div>
                    <div class="get-content">
                        <h3>Sessions Recording</h3>
                        <p>Get recordings of all your classes so that you never miss on your preparation.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12 col-xs-12">
                <div class="get-item">
                    <div>
                        <figure class="get-img">
                            <img src="assets/img/neet-landing/g6.png" alt="" class="img-fluid">
                        </figure>
                    </div>
                    <div class="get-content">
                        <h3>Assignments and Tests</h3>
                        <p>You will have assignments and notes for every lecture along with chapter wise tests to
                            keep improving your performance.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="number-field" [formGroup]='mobileNumberForm'>
                <span class="code">+ 91</span>
                <input type="tel" maxlength="10" class="numbertest-input"  placeholder="MOBILE NUMBER" formControlName='mobilenumber'>
                <button type="button" (click)="signup('neet_lc_2', {number: mobileNumberForm.value.mobilenumber, dialCode: '+91'})" [disabled]="!mobileNumberValid" class="start-btn"><b>START
                        LEARNING</b></button>
            </div>
        </div>
        <div class="d-flex justify-content-center IL_sc-click font-weight-bold assessment_mb-25">
            <span class="assessment_mt-10" *ngIf="tenant != 'srichaitanya'">Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
        </div>
    </div>
</section>
<!-- Live Class starts -->
<section class="liveclass-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-12 col-xs-12">
                <div class="liveclass-wrapper">
                    <div class="liveclass-head">
                        <h1>Experience The<span class="live-span"><br> Live Class</span></h1>
                        <p>Meet your faculty and get the real experience </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12 col-xs-12">
                <div>
                    <iframe width="100%" height="325" src="https://www.youtube.com/embed/UlfMU2CTBVI" frameborder="0"
                        allow="autoplay; encrypted-media" allowfullscreen=""></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Our faculty -->
<section class="faculty-area">
    <div class="container">
        <div class="ourfaculty-head">
            <h1>Our <span class="head-span">Faculties</span> </h1>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="faculty-flex">
                    <div class="item">
                        <div class="inner-box">
                            <div class="faculty-img">
                                <a href="">
                                    <figure>
                                        <img src="assets/img/neet-landing/Vibhati.png" alt="Vibhati Jain" />
                                    </figure>
                                </a>
                            </div>
                            <div class="inner-content">
                                <h4>Vibhati Jain</h4>
                                <h6>Sr. Physics Faculty</h6>
                                <p>Vibhati Jain, B.Tech. from Nirma University, Ahmedabad has 5 years of extensive
                                    experience in coaching 10000+
                                    students. Her students have secured 99 and 100 percentiles across NEET. She has
                                    also coached students from 10
                                    countries other than India.</p>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="inner-box">
                            <div class="faculty-img">
                                <a href="">
                                    <figure>
                                        <img src="assets/img/neet-landing/Aman.png" alt="Aman Kumar" />
                                    </figure>
                                </a>
                            </div>
                            <div class="inner-content">
                                <h4>Aman Varma</h4>
                                <h6>Sr. Chemistry Faculty</h6>
                                <p>Aman Kumar Varma, B.E. in Chemical Engineering from Sir Visvesvaraya Institute of
                                    Technology, Nashik, has 8+ years of
                                    experience in teaching Chemistry for NEET & JEE.</p>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="inner-box">
                            <div class="faculty-img">
                                <a href="">
                                    <figure>
                                        <img src="assets/img/neet-landing/Swagata.png" alt="Swagata Mukherjee" />
                                    </figure>
                                </a>
                            </div>
                            <div class="inner-content">
                                <h4>Swagata Mukherjee</h4>
                                <h6>Sr. Zoology Faculty</h6>
                                <p>Swagata Mukherjee, M.Sc. in Applied Genetics from Bangalore University, has 6+
                                    years of experience in teaching
                                    Zoology and has taught top batches to produce numerous double digit ranks and
                                    many selections in AIIMS, AFMC and
                                    IISER.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- footer area -->
<app-footer></app-footer>
<script src="https://cdn.jsdelivr.net/npm/popper.js@1.16.1/dist/umd/popper.min.js"
    integrity="sha384-9/reFTGAW83EW2RDu2S0VKaIzap3H66lZH81PoYlFhbGU+6BZp6G7niu735Sk7lN"
    crossorigin="anonymous"></script>